function initCommonHome() {
  if (!$(".d-lg-none").is(":hidden")) {
    $(".section-gifts-wraper")
      .children(":first-child")
      .children(".section-gifts-cat")
      .children(".rect")
      .trigger("mouseenter");
  }

  $(".section-howitworks-tiles li").each(function () {
    $(this).prepend(
      $("<span />", {
        class: "section-howitworks-tiles__number",
        html: "<span><span><span></span></span></span>",
      })
    );
  });

  $(".section-gifts-cat")
    .mouseenter(function () {
      // $(this).children('.section-gifts-childlink').show();
      $(".section-gifts-cat").trigger("mouseleave");

      if ($(".d-lg-none").is(":hidden")) {
        // $(this).children('.section-gifts-childlinks').css('width',$(this).width());

        $(this).css("border", "0px");

        $(this).css("background-color", "#5b2292");

        if ($(this).children(".section-gifts-childlinks").length) {
          $(this).children(".section-gifts-childlinks").show();
          $(this).children(".section-gifts-catlink").hide();
        } else {
          $(this).children(".section-gifts-catlink").css("color", "#FFFFFF");
        }

        $(this)
          .children(".section-gifts-catimage")
          .css(
            "filter",
            "invert(100%) sepia(66%) saturate(0%) hue-rotate(279deg) brightness(104%) contrast(101%)"
          );
      } else {
        /*$('.section-gifts-catinfo').html($(this).children('.section-gifts-childlinks').html());
       $(this).css('background-color','#5b2292');
       $(this).children('.section-gifts-catlink').css('color','#FFFFFF');
       $(this).children('.section-gifts-catimage').css('filter','invert(100%) sepia(66%) saturate(0%) hue-rotate(279deg) brightness(104%) contrast(101%)');*/
      }
    })
    .mouseleave(function () {
      if ($(".d-lg-none").is(":hidden")) {
        $(this).css("background-color", "#FFFFFF");

        if ($(this).children(".section-gifts-childlinks").length) {
          $(this).children(".section-gifts-childlinks").hide();
          $(this).children(".section-gifts-catlink").show();
        } else {
          $(this).children(".section-gifts-catlink").css("color", "#5b2292");
        }

        $(this).children(".section-gifts-catimage").css("filter", "none");

        $(this).css("border", "2px solid #5b2292");
      } else {
        /*$(this).css('background-color','#FFFFFF');
      $(this).children('.section-gifts-catlink').css('color','#5b2292');
      $(this).children('.section-gifts-catimage').css('filter','none');*/
      }
    });

  $(".section-gifts .rect").mouseenter(function () {
    // $(this).children('.section-gifts-childlink').show();
    $(".section-gifts-cat").css("background-color", "#FFFFFF");
    $(".section-gifts-cat")
      .children(".section-gifts-catlink")
      .css("color", "#5b2292");

    $(".section-gifts-cat")
      .children(".section-gifts-catimage")
      .css("filter", "none");

    // console.log($(this).parent().html());

    $(".section-gifts-catinfo").html(
      $(this).parent().children(".section-gifts-childlinks").html()
    );
    $(this).parent().css("background-color", "#5b2292");
    $(this).parent().children(".section-gifts-catlink").css("color", "#FFFFFF");
    $(this)
      .parent()
      .children(".section-gifts-catimage")
      .css(
        "filter",
        "invert(100%) sepia(66%) saturate(0%) hue-rotate(279deg) brightness(104%) contrast(101%)"
      );
  });
}

// function redirect(obj) {
//   if (!$(".d-lg-none").is(":hidden")) {
//     // window.location.href=$(obj).data('link');
//   }
// }
